import React from 'react';

export default function ScrollMarquee({ 
  items = [
    { label: 'Bespoke Color' },
    { label: 'Precision Cutting', gold: true },
    { label: 'AI Hair Analysis' },
    { label: 'Bridal Hair', gold: true },
    { label: 'Premium Treatments' },
    { label: 'Total Look', gold: true },
  ] 
}) {
  // Duplicate για seamless loop
  const allItems = [...items, ...items];
  
  return (
    <div className="bg-warm-black text-cream py-[18px] overflow-hidden whitespace-nowrap">
      <div className="marquee-track inline-block animate-marquee font-serif italic text-[22px]">
        {allItems.map((item, idx) => (
          <span 
            key={idx}
            className={`mx-[30px] inline-block ${item.gold ? 'text-gold-light' : ''}`}
          >
            {item.label}
            <span className="ml-[30px] text-gold-light text-sm not-italic align-middle">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}